import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function PolazisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PolazisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M81.7,80.7H18.9V68.6h0.2l-6.4-6l7.6-6.7l-6.7-6.2l5.2-4.8l-1.5-1.4l17.2-28.2l17.2,28.2l-1.5,1.4l5.2,4.8
	l-6.7,6.2l3.3,2.9v-4.1h29.6L81.7,80.7L81.7,80.7z"/>
      <polygon fill="#FF0000" points="77.9,63 77.9,58.5 55.9,58.5 55.9,63 64.6,63 64.6,72.4 37,72.4 37,61.1 48.9,64.5 50.8,62.7 
	38.3,51.7 37,47.8 48,51.6 50,49.7 38.3,39 36.8,34.8 43.3,36.9 34.6,22.6 25.9,36.9 32.4,34.8 30.9,39 19.2,49.7 21.1,51.6 
	32.2,47.8 30.9,51.7 18.4,62.7 20.3,64.5 32.2,61.1 32.2,72.4 22.7,72.4 22.7,76.9 32.2,76.9 77.9,76.9 77.9,72.4 69.3,72.4 
	69.3,63 "/>
    </svg>
  </SvgIcon>
}

export default PolazisteIcon;
